// src/admin/AdminBanor.jsx
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import AdminShell from "./AdminShell";
import { firestore, storage } from "../firebase";

import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

/* ---------- UI (nya designen) ---------- */

const Grid = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: 1.1fr 0.9fr;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 14px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.06);
`;

const Label = styled.div`
  font-weight: 950;
  margin: 10px 0 6px;
  color: #111827;
`;

const Input = styled.input`
  width: 95%;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  padding: 12px;
  font-weight: 800;
  background: #fff;

  &:focus {
    outline: none;
    border-color: rgba(15, 118, 110, 0.45);
    box-shadow: 0 0 0 4px rgba(15, 118, 110, 0.12);
  }
`;

const Textarea = styled.textarea`
  width: 95%;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  padding: 12px;
  font-weight: 800;
  min-height: 92px;
  background: #fff;

  &:focus {
    outline: none;
    border-color: rgba(15, 118, 110, 0.45);
    box-shadow: 0 0 0 4px rgba(15, 118, 110, 0.12);
  }
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 12px;
`;

const Btn = styled.button`
  appearance: none;
  border: 1px solid rgba(15, 118, 110, 0.22);
  background: #0f766e;
  color: #fff;
  font-weight: 950;
  border-radius: 999px;
  padding: 10px 14px;
  cursor: pointer;

  &:disabled {
    opacity: 0.65;
    cursor: wait;
    transform: none;
  }

  &:hover {
    filter: brightness(1.03);
    transform: translateY(-1px);
  }
`;

const Ghost = styled(Btn)`
  background: #fff;
  color: #111827;
  border: 1px solid #e5e7eb;

  &:hover {
    background: #f9fafb;
  }
`;

const Danger = styled(Btn)`
  background: rgba(233, 78, 27, 0.08);
  color: #e94e1b;
  border: 1px solid rgba(233, 78, 27, 0.28);
`;

const Muted = styled.div`
  color: #6b7280;
  font-weight: 800;
  font-size: 12px;
  line-height: 1.45;
`;

const Item = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 12px;
  display: grid;
  gap: 10px;
`;

const ItemTop = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const Thumb = styled.img`
  width: 84px;
  height: 64px;
  object-fit: cover;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #000;
`;

const TitleLine = styled.div`
  font-weight: 950;
  color: #111827;
`;

const SmallPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 950;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.1);
  border: 1px solid rgba(15, 118, 110, 0.18);
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
`;

/* ✅ NEW: filter tabs */
const FilterRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 10px 0 12px;
`;

const FilterTab = styled.button`
  appearance: none;
  border-radius: 999px;
  padding: 10px 14px;
  font-weight: 950;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  background: ${({ $active }) => ($active ? "#0f766e" : "#fff")};
  color: ${({ $active }) => ($active ? "#fff" : "#111827")};

  &:hover {
    background: ${({ $active }) => ($active ? "#0f766e" : "#f9fafb")};
    transform: translateY(-1px);
  }
`;

/* ---------- Helpers ---------- */

function safeFileName(name) {
  return (name || "file")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9.\-_]/g, "");
}

function makeStoragePath(folder, file) {
  return `${folder}/${Date.now()}-${safeFileName(file?.name)}`;
}

/* ---------- Component ---------- */

export default function AdminBanor() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  // form (som din)
  const [courseName, setCourseName] = useState("");
  const [courseType, setCourseType] = useState("");
  const [holeCount, setHoleCount] = useState("");
  const [handicap, setHandicap] = useState("");
  const [tip, setTip] = useState("");

  const [courseFile, setCourseFile] = useState(null);
  const [tipFile, setTipFile] = useState(null);

  /* ✅ NEW: sort/filter-flik */
  const [filter, setFilter] = useState("all"); // "all" | "adventure" | "felt"

  /* ✅ NEW: robust typ-tolkning */
  const normalizeType = (t) => String(t || "").toLowerCase();

  const getTypeBucket = (t) => {
    const s = normalizeType(t);

    // fångar: filt, filtgolf, felt, filtbana osv
    if (s.includes("filt") || s.includes("felt")) return "felt";

    // fångar: äventyr, aventyr, äventyrsgolf, adventure osv
    if (s.includes("äventyr") || s.includes("aventyr") || s.includes("advent")) return "adventure";

    // fallback
    if (s.trim() === "filt") return "felt";
    if (s.trim() === "äventyr" || s.trim() === "aventyr") return "adventure";

    return "other";
  };

  const coursePreview = useMemo(
    () => (courseFile ? URL.createObjectURL(courseFile) : ""),
    [courseFile]
  );
  const tipPreview = useMemo(
    () => (tipFile ? URL.createObjectURL(tipFile) : ""),
    [tipFile]
  );

  const load = async () => {
    const snap = await getDocs(collection(firestore, "golf_courses"));
    const arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    // sortera nyaste först (om createdAt finns)
    arr.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
    setItems(arr);
  };

  useEffect(() => {
    load();
    return () => {
      if (coursePreview) URL.revokeObjectURL(coursePreview);
      if (tipPreview) URL.revokeObjectURL(tipPreview);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredItems = useMemo(() => {
    if (filter === "all") return items;
    return items.filter((it) => getTypeBucket(it.type) === filter);
  }, [items, filter]);

  const reset = () => {
    setCourseName("");
    setCourseType("");
    setHoleCount("");
    setHandicap("");
    setTip("");
    setCourseFile(null);
    setTipFile(null);
  };

  const uploadOne = async (file, storageFolder) => {
    const path = makeStoragePath(storageFolder, file);
    const r = ref(storage, path);
    await uploadBytes(r, file);
    const url = await getDownloadURL(r);
    return { url, path };
  };

  const addCourse = async () => {
    if (!courseName.trim() || !courseType.trim()) return alert("Fyll i namn och typ.");
    if (!holeCount || !handicap) return alert("Fyll i antal hål och handikapp.");
    if (!tip.trim()) return alert("Fyll i tipstext.");
    if (!courseFile || !tipFile) return alert("Välj både banbild och tipsbild.");

    setBusy(true);
    try {
      // ✅ samma folderstruktur som din kod
      const courseUp = await uploadOne(courseFile, "golf_courses");
      const tipUp = await uploadOne(tipFile, "golf_courses/tips");

      await addDoc(collection(firestore, "golf_courses"), {
        name: courseName.trim(),
        type: courseType.trim(),
        holes: Number(holeCount) || 0,
        handicap: Number(handicap) || 0,
        tip: tip.trim(),

        imageUrl: courseUp.url,
        tipImageUrl: tipUp.url,

        // extra (för delete framåt)
        storagePath: courseUp.path,
        tipStoragePath: tipUp.path,

        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      reset();
      await load();
      alert("Bana tillagd!");
    } catch (e) {
      alert(e?.message || "Något gick fel vid uppladdningen.");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (it) => {
    if (!window.confirm(`Ta bort "${it.name}"?`)) return;

    setBusy(true);
    try {
      await deleteDoc(doc(firestore, "golf_courses", it.id));

      // Ta bort bilder i Storage
      const tasks = [];

      if (it.storagePath) tasks.push(deleteObject(ref(storage, it.storagePath)));
      else if (it.imageUrl) tasks.push(deleteObject(ref(storage, it.imageUrl)).catch(() => {}));

      if (it.tipStoragePath) tasks.push(deleteObject(ref(storage, it.tipStoragePath)));
      else if (it.tipImageUrl) tasks.push(deleteObject(ref(storage, it.tipImageUrl)).catch(() => {}));

      await Promise.all(tasks);

      await load();
      alert("Borttagen!");
    } catch (e) {
      alert(e?.message || "Kunde inte ta bort bana.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminShell title="Banor (upload)">
      <Grid>
        <Card>
          <h3 style={{ margin: 0 }}>Lägg till golfbana</h3>

          <Label>Bananamn</Label>
          <Input
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
            placeholder="Bananamn"
          />

          <Label>Bantyp</Label>
          <Input
            value={courseType}
            onChange={(e) => setCourseType(e.target.value)}
            placeholder="Äventyr / Filt"
          />

          <Row>
            <div style={{ flex: "1 1 90%" }}>
              <Label>Antal hål</Label>
              <Input
                type="number"
                value={holeCount}
                onChange={(e) => setHoleCount(e.target.value)}
                placeholder="Ex 18"
              />
            </div>

            <div style={{ flex: "1 1 90%" }}>
              <Label>Handikapp</Label>
              <Input
                type="number"
                value={handicap}
                onChange={(e) => setHandicap(e.target.value)}
                placeholder="0"
              />
            </div>
          </Row>

          <Label>Tips</Label>
          <Textarea value={tip} onChange={(e) => setTip(e.target.value)} placeholder="Tips..." />

          <Label>Bild på banan</Label>
          <Input
            type="file"
            accept="image/*"
            onChange={(e) => setCourseFile(e.target.files?.[0] || null)}
          />
          {coursePreview ? (
            <div style={{ marginTop: 10 }}>
              <Thumb
                src={coursePreview}
                alt="Preview banbild"
                style={{ width: 220, height: 140 }}
              />
            </div>
          ) : null}

          <Label>Tipsbild</Label>
          <Input
            type="file"
            accept="image/*"
            onChange={(e) => setTipFile(e.target.files?.[0] || null)}
          />
          {tipPreview ? (
            <div style={{ marginTop: 10 }}>
              <Thumb
                src={tipPreview}
                alt="Preview tipsbild"
                style={{ width: 220, height: 140 }}
              />
            </div>
          ) : null}

          <Row>
            <Btn type="button" onClick={addCourse} disabled={busy}>
              {busy ? "Sparar…" : "Lägg till"}
            </Btn>
            <Ghost type="button" onClick={reset} disabled={busy}>
              Rensa
            </Ghost>
          </Row>

          <Muted style={{ marginTop: 10 }}>
            Sparar i <b>Firestore: golf_courses</b> och laddar upp till <b>Storage: golf_courses/</b> +{" "}
            <b>golf_courses/tips/</b>.
          </Muted>
        </Card>

        <Card>
          <h3 style={{ margin: 0 }}>Befintliga banor</h3>
          <div style={{ height: 10 }} />

          {/* ✅ NEW: sorteringsflikar */}
          <FilterRow>
            <FilterTab type="button" $active={filter === "all"} onClick={() => setFilter("all")}>
              Alla
            </FilterTab>
            <FilterTab
              type="button"
              $active={filter === "adventure"}
              onClick={() => setFilter("adventure")}
            >
              Äventyr
            </FilterTab>
            <FilterTab type="button" $active={filter === "felt"} onClick={() => setFilter("felt")}>
              Filt
            </FilterTab>
          </FilterRow>

          {filteredItems.length === 0 ? (
            <Muted>
              Inga banor för{" "}
              <b>{filter === "all" ? "Alla" : filter === "adventure" ? "Äventyr" : "Filt"}</b>.
            </Muted>
          ) : (
            filteredItems.map((it) => (
              <Item key={it.id}>
                <ItemTop>
                  <Thumb src={it.imageUrl} alt={it.name || "Bana"} />
                  <div style={{ display: "grid", gap: 6 }}>
                    <TitleLine>
                      {Number(it.holes || 0)} hål • {it.name}
                    </TitleLine>
                    <SmallPill>
                      Typ: {it.type || "-"} • Hcp: {Number(it.handicap || 0)}
                    </SmallPill>
                    <Muted style={{ maxWidth: 420 }}>
                      Tips: {String(it.tip || "").slice(0, 90)}
                      {String(it.tip || "").length > 90 ? "…" : ""}
                    </Muted>
                  </div>
                </ItemTop>

                <Row>
                  <Ghost as="a" href={it.imageUrl} target="_blank" rel="noreferrer">
                    Öppna banbild
                  </Ghost>
                  {it.tipImageUrl ? (
                    <Ghost as="a" href={it.tipImageUrl} target="_blank" rel="noreferrer">
                      Öppna tipsbild
                    </Ghost>
                  ) : null}
                  <Danger type="button" onClick={() => remove(it)} disabled={busy}>
                    Ta bort
                  </Danger>
                </Row>
              </Item>
            ))
          )}
        </Card>
      </Grid>
    </AdminShell>
  );
}

